import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "w-full bg-opacity-40 bg-primary-light-blue overflow-y-auto rounded-xl",
  style: {"height":"21rem"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold tracking-wide uppercase text-blue-900 pt-4 pl-4" }, "Ülesvõtted", -1)
const _hoisted_3 = { class: "space-y-2 divide-y-2 divide-gray-200 py-5 px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SnapshotChartItem = _resolveComponent("SnapshotChartItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedSnapShots, (item) => {
        return (_openBlock(), _createBlock(_component_SnapshotChartItem, {
          key: item[0],
          title: item[0],
          value: item[1],
          maxValue: _ctx.maxValue
        }, null, 8, ["title", "value", "maxValue"]))
      }), 128))
    ])
  ]))
}